import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import { translate } from 'i18n/i18n'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'
import { unitConverter } from 'utils/unitConverter/unitConverter'

const insectTrapCatchesBlockOrPointRenderer = ({ valueType }: { valueType: string }) => {
  const insectId = Number(valueType.split('_').slice(-1)[0])
  const baseLabel = twoItemLabel([translate.phrases.banyanApp('Trap Catches'), getInsectNameFromId(insectId)])

  return makeNumberRenderer({
    baseLabel,
    render: (n) => unitConverter.insectTrapCatches(n, { insectId, decimalPlaces: 0 }).valueAsString(),
  })
}

export const insectTrapCatches = {
  label: (valueType: string) => {
    const insectId = Number(valueType.split('_').slice(-1)[0])

    return unitConverter.insectTrapCatches(null, { insectId }).titleWithoutUnit()
  },
  block: insectTrapCatchesBlockOrPointRenderer,
  point: insectTrapCatchesBlockOrPointRenderer,
}
